export default "__VITE_ASSET__DeDRrcqe__"